// Reuses maxSalesPriceCalculatorAddFields.numberOfSets and .stepsDecks.
// These are entry defaults, not a change to the lender's allowance tables.
const DEFAULT_STEP_SETS = 2;
const DEFAULT_STEPS_PER_SET = 1000;
const defaultStepsAmount = sets => (Number(sets) || 0) * DEFAULT_STEPS_PER_SET;

module.exports = { DEFAULT_STEP_SETS, DEFAULT_STEPS_PER_SET, defaultStepsAmount };
